import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes.ts';

export const exportOneflightRequests = [
  http.post(`*${apiRoutes.exportOneflight(':campaignId')}`, () => {
    return HttpResponse.json({ brandId: '123' });
  }),
];
